import axios from "axios";
import { ip_back } from "../../config";
import moment from "moment/moment";
import { httpErrorPayload } from "../../utils/httpErrorPayload";
import { assertVideoUploadAllowed } from "../../utils/videoUploadNetwork";

const getToken = () => {
  return localStorage.getItem("token");
};

const headers = () => {
  const token = getToken();

  return {
    headers: {
      Authorization: token,
    },
  };
};

const changelang = async (lng) => {
  try {
    const params = {
      lang: lng,
    };
    const response = await axios.post(
      `${ip_back}api/user/changeLang`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const profile = async (opts = {}) => {
  try {
    const userRaw = JSON.parse(localStorage.getItem("user") || "{}");
    let langBase = (
      localStorage.getItem("i18nextLng") ||
      localStorage.getItem("lng") ||
      "en"
    )
      .split("-")[0]
      .toLowerCase();
    if (langBase === "gr") langBase = "de";
    if (langBase === "sp") langBase = "es";
    if (!["en", "fr", "de", "es", "nl", "pt"].includes(langBase)) langBase = "en";

    const params = {};
    if (opts.view_user_id) params.view_user_id = opts.view_user_id;
    if (opts.view_player_id) params.view_player_id = opts.view_player_id;
    const clubId = String(
      opts.club_id ||
        userRaw.club_id ||
        userRaw.club_details?.club_id ||
        userRaw.club?.club_id ||
        ""
    ).trim();
    if (clubId) params.club_id = clubId;

    const response = await axios.get(`${ip_back}api/user/getProfile`, {
      headers: {
        ...headers().headers,
        "user-id": userRaw.user_id,
        "Accept-Language": langBase,
      },
      params: Object.keys(params).length ? params : undefined,
    });
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const getMyClubs = async () => {
  try {
    const response = await axios.get(`${ip_back}api/user/myClubs`, headers());
    if (response.data?.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error.code === 401) localStorage.clear();
    throw error.response?.data ?? {
      status: "error",
      message: error.message || "Network error",
    };
  }
};

const switchClub = async (club_id) => {
  try {
    const response = await axios.post(
      `${ip_back}api/user/switchClub`,
      { club_id },
      headers()
    );
    if (response.data?.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error.code === 401) localStorage.clear();
    throw error.response?.data ?? {
      status: "error",
      message: error.message || "Network error",
    };
  }
};

const editprofile = async (file, data) => {
  console.log(typeof Number(data.type));
  try {
    const params = new FormData();
    params.append("typeUser_id", Number(data.type));
    params.append("user_alias", data.alias != null ? String(data.alias).trim() : "");
    params.append("firstName", data.fname);
    params.append("lastName", data.lname);
    params.append("email", data.email);
    params.append("club_id", data.clubid);
    params.append("sex", data.gender);
    params.append("dateBorn", data.bday);
    params.append("height", String(data.height));
    params.append("weight", String(data.weight));
    
    // Add player-specific fields
    if (data.grip) {
      params.append("player_grip", data.grip);
    }
    if (data.hand) {
      params.append("player_hand", data.hand);
    }
    if (data.level) {
      params.append("player_level", data.level);
    }
    if (data.style) {
      params.append("player_style", data.style);
    }
    
    {
      file && params.append("user_image", file);
    }

    const response = await axios.put(
      `${ip_back}api/user/updateProfile`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const sendinvite = async (clubid, email) => {
  try {
    const params = {
      club_id: clubid,
      email: email,
    };
    const response = await axios.post(
      `${ip_back}api/superAdmin/userInvitation`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const superadmineditprofile = async (data) => {
  try {
    const params = new FormData();
    params.append("full_name", data.fname);
    params.append("email", data.email);

    const response = await axios.post(
      `${ip_back}api/superAdmin/updateProfile`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const changepassword = async (data) => {
  const params = {
    oldPassword: "123456",
    newPassword: "12345678",
  };
  try {
    const response = await axios.put(
      `${ip_back}api/user/changePassword`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const superadminchangepassword = async (data) => {
  const params = {
    oldPassword: "123456",
    newPassword: "12345678",
  };
  try {
    const response = await axios.put(
      `${ip_back}api/superAdmin/changePassword`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const homepageadmin = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/user/homePage`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const homemetric = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/user/homeMetrix`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const homepageuser = async (date) => {
  try {
    const datei = moment(date).format("YYYY-MM-DD");
    const params = date ? { gr_created_date: datei } : {};

    const response = await axios.post(
      `${ip_back}api/user/homePageUser`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const usertype = async () => {
  try {
    const response = await axios.get(`${ip_back}api/typeUser/get`, headers());
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const inviteuserinfo = async (token) => {
  try {
    const params = {
      invitation_token: token,
    };
    const response = await axios.post(
      `${ip_back}api/user/invitationTokenDecode`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const alluserlist = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/admin/listUsers`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const allclublist = async (params = {}) => {
  try {
    // Build query string from params
    const queryParams = new URLSearchParams();
    if (params.country) queryParams.append('country', params.country);
    if (params.search) queryParams.append('search', params.search);
    if (params.page != null && params.page !== "") queryParams.append("page", String(params.page));
    if (params.limit != null && params.limit !== "") queryParams.append("limit", String(params.limit));
    
    const queryString = queryParams.toString();
    const url = queryString ? `${ip_back}api/superAdmin/getClub?${queryString}` : `${ip_back}api/superAdmin/getClub`;
    
    const response = await axios.get(url, headers());
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    // Empty search used to return HTTP 404 — treat as an empty list.
    if (error.response?.status === 404) {
      return { data: { status: "success", message: "No clubs found", data: [], pagination: { currentPage: 1, limit: 10, total: 0, totalPages: 0, nextPage: false } } };
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

/** Super-admin club license + monthly eval-session usage (unlimited still reports used). */
const getClubLicenseUsage = async (club_id) => {
  try {
    const response = await axios.get(
      `${ip_back}api/superAdmin/getClubLicense/${encodeURIComponent(club_id)}`,
      headers()
    );
    if (response.data?.status === "error") throw response.data;
    return response.data?.data || null;
  } catch (error) {
    if (error?.response?.status === 401 || error?.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const getClubUsers = async (club_id) => {
  try {
    const response = await axios.get(
      `${ip_back}api/superAdmin/getClubUsers/${club_id}`,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const deleteClub = async (club_id) => {
  try {
    const response = await axios.delete(
      `${ip_back}api/superAdmin/deleteClub/${club_id}`,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const listFlttMatchProposals = async (club_id) => {
  const response = await axios.get(
    `${ip_back}api/superAdmin/flttMatchProposals/${club_id}`,
    headers()
  );
  if (response.data && response.data.status === "error") throw response.data;
  return response;
};

const decideFlttMatchProposal = async (club_id, proposal_id, decision) => {
  const response = await axios.post(
    `${ip_back}api/superAdmin/flttMatchProposals/${club_id}/${proposal_id}/${decision}`,
    {},
    headers()
  );
  if (response.data && response.data.status === "error") throw response.data;
  return response;
};

const updateClubFromFLTT = async (club_id, forceScrape = false) => {
  try {
    // Respect cache logic by default (forceScrape = false)
    const forceScrapeParam = forceScrape === true || forceScrape === 'true' || forceScrape === 1 || forceScrape === '1' ? true : false;
    
    // Build URL with query parameter AND send it in body (double approach to ensure it's received)
    const url = `${ip_back}api/superAdmin/updateClubFromFLTT/${club_id}?forceScrape=${forceScrapeParam}`;
    
    console.log(`📡 API Call: POST ${url}`);
    console.log(`   forceScrape parameter: ${forceScrapeParam} (original: ${forceScrape}, type: ${typeof forceScrape})`);
    console.log(`   Full URL: ${url}`);
    console.log(`   Request body will include: { forceScrape: ${forceScrapeParam} }`);
    
    // Make POST request with parameter in BOTH URL and body
    const response = await axios.post(
      url,
      { forceScrape: forceScrapeParam }, // Send in body
      headers()
    );
    
    console.log(`📥 API Response received:`, {
      status: response.status,
      statusText: response.statusText,
      dataStatus: response.data?.status,
      hasData: !!response.data
    });
    
    if (response.data && response.data.status === "error") {
      console.error(`❌ API returned error:`, response.data);
      throw response.data;
    } else if (!response.data) {
      console.error(`❌ API response has no data`);
      throw {
        status: "error",
        message: "No data received from server",
        data: null
      };
    } else {
      console.log(`✅ API call successful`);
      return response;
    }
  } catch (error) {
    console.error(`❌ API call failed:`, error);
    
    if (error.code === 401 || (error.response && error.response.status === 401)) {
      console.log(`🔒 Unauthorized - clearing localStorage`);
      localStorage.clear();
    }
    
    // If error.response exists, throw the response data
    if (error.response && error.response.data) {
      console.error(`📥 Error response data:`, error.response.data);
      throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
    }
    
    // If error is already formatted (from throw response.data above)
    if (error.status === "error") {
      throw error;
    }
    
    const isConnectionRefused =
      error.code === 'ERR_NETWORK' ||
      error.message?.includes('Network Error') ||
      error.message?.includes('ERR_CONNECTION_REFUSED');

    // Otherwise, throw a formatted error
    throw {
      status: "error",
      message: isConnectionRefused
        ? "Cannot reach the backend server. Ensure the API is running on the expected port."
        : (error.message || "Network error occurred"),
      data: {
        error: error.message,
        code: error.code,
        club_id: club_id
      }
    };
  }
};

const importClubFromWebsite = async (url) => {
  try {
    const response = await axios.post(
      `${ip_back}api/superAdmin/importClubFromWebsite`,
      { url },
      { ...headers(), timeout: 90000 }
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response.data;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data || error;
  }
};

const addclub = async (image, info) => {
  console.log(typeof info.table);
  try {
    const params = new FormData();
    params.append("club_name", info.name);
    params.append("club_email", info.email);
    params.append("club_address", info.address);
    // params.append("club_lat", 0);
    // params.append("club_lon", 0);
    params.append("troom_name", info.troom);
    params.append("number_of_tables", info.table);
    if (info.country) {
      params.append("country", info.country);
      params.append("club_country", info.country);
    }
    params.append("club_image", image);

    const response = await axios.post(
      `${ip_back}api/superAdmin/createClub`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const updateclub = async (image, info, id) => {
  try {
    const params = new FormData();
    params.append("club_name", info.name);
    params.append("club_email", info.email);
    params.append("club_address", info.address);
    if (info.lat !== undefined) params.append("club_lat", info.lat);
    if (info.lon !== undefined) params.append("club_lon", info.lon);
    if (info.website) params.append("club_website", info.website);
    if (info.phone) params.append("phone_mobile", info.phone);
    if (info.postalCode) params.append("postal_code", info.postalCode);
    if (info.city) params.append("city", info.city);
    if (info.country) params.append("country", info.country);
    if (info.description) params.append("club_description", info.description);
    if (info.license_tier) params.append("license_tier", info.license_tier);
    if (info.addon_hr !== undefined) params.append("addon_hr", info.addon_hr);
    // Add founded_date if provided
    if (info.foundedDate) {
      params.append("founded_date", info.foundedDate);
    }
    if (image) params.append("club_image", image);

    // Use the club route instead of superAdmin route to allow club admins to update
    const response = await axios.put(
      `${ip_back}api/club/updateClub/${id}`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data || error;
  }
};

const uploadClubLogo = async (clubId, file) => {
  try {
    const params = new FormData();
    params.append("logo", file);
    const response = await axios.post(
      `${ip_back}api/brand/${clubId}/upload-logo?type=main`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data || error;
  }
};

const getPilotWeeklyDigest = async (clubId, weekStart) => {
  try {
    const response = await axios.get(
      `${ip_back}api/superAdmin/pilotWeeklyDigest/${clubId}`,
      {
        ...headers(),
        params: weekStart ? { week_start: weekStart } : undefined,
      }
    );
    if (response.data.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error?.response?.status === 401) localStorage.clear();
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const getPilotBiClubs = async (weekStart) => {
  try {
    const response = await axios.get(`${ip_back}api/superAdmin/pilotBiClubs`, {
      ...headers(),
      params: weekStart ? { week_start: weekStart } : undefined,
    });
    if (response.data.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error?.response?.status === 401) localStorage.clear();
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const getCaptureQosSummary = async ({ from, to, runId } = {}) => {
  try {
    const response = await axios.get(
      `${ip_back}api/superAdmin/captureQos/summary`,
      {
        ...headers(),
        params: {
          ...(from ? { from } : {}),
          ...(to ? { to } : {}),
          ...(runId ? { run_id: runId } : {}),
        },
      }
    );
    if (response.data.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error?.response?.status === 401) localStorage.clear();
    throw (
      error.response?.data ?? {
        status: "error",
        message: error.message || "Network error",
      }
    );
  }
};

const downloadPilotWeeklyDigestCsv = async (clubId, weekStart) => {
  const response = await axios.get(
    `${ip_back}api/superAdmin/pilotWeeklyDigest/${clubId}/csv`,
    {
      ...headers(),
      params: weekStart ? { week_start: weekStart } : undefined,
      responseType: "blob",
    }
  );
  const blob = new Blob([response.data], { type: "text/csv;charset=utf-8" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `club0-weekly-${weekStart || "current"}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

const postChampionSignal = async (clubId, answers) => {
  try {
    const response = await axios.post(
      `${ip_back}api/superAdmin/pilotChampionSignal/${clubId}`,
      answers,
      headers()
    );
    if (response.data.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error?.response?.status === 401) localStorage.clear();
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const allpermissions = async () => {
  try {
    const response = await axios.get(
      `${ip_back}api/superAdmin/getPermissions`,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const allroles = async () => {
  try {
    // Try admin endpoint first (for regular admins)
    const response = await axios.get(
      `${ip_back}api/admin/roleList`,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    // Fallback to superAdmin endpoint if admin endpoint fails (for super admins)
    if (error.response && error.response.status === 403 || error.response && error.response.status === 404) {
      try {
        const fallbackResponse = await axios.get(
          `${ip_back}api/superAdmin/roleList`,
          headers()
        );
        if (fallbackResponse.data.status === "error") {
          throw fallbackResponse.data;
        } else {
          return fallbackResponse;
        }
      } catch (fallbackError) {
        if (fallbackError.code === 401) {
          localStorage.clear();
        }
        throw fallbackError.response ? fallbackError.response.data : fallbackError;
      }
    }
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response ? error.response.data : error;
  }
};
const addroles = async (name, perm) => {
  try {
    const params = {
      role_name: name,
      permissions: perm,
    };
    const response = await axios.post(
      `${ip_back}api/superAdmin/createRoleWithPermission`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const updateroles = async (name, perm, remove) => {
  try {
    const params = {
      role_name: name,
      createRoleWithPermission: perm,
      remove_per_ids: remove,
    };

    const response = await axios.post(
      `${ip_back}api/superAdmin/createRoleWithPermission`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const troomlist = async () => {
  try {
    const params = {};
    const response = await axios.post(
      `${ip_back}api/superAdmin/trainingRoomList`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const createpermissions = async () => {
  try {
    const response = await axios.get(
      `${ip_back}api/superAdmin/createPermission`,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const playerlist = async (id) => {
  try {
    const params = {
      club_id: id,
    };
    const response = await axios.post(
      `${ip_back}api/admin/playerList`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const coachlist = async (id) => {
  try {
    const params = {
      club_id: id,
    };
    const response = await axios.post(
      `${ip_back}api/admin/coachList`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const contenttypelist = async () => {
  try {
    const token = getToken();
    if (!token) {
      console.error("❌ contenttypelist - No token found in localStorage");
      throw new Error("No token available. Please log in again.");
    }
    
    console.log("🔑 contenttypelist - Token found, making request to getTSMode");
    const response = await axios.get(
      `${ip_back}api/training/getTSMode`,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    console.error("❌ contenttypelist - Error:", error);
    console.error("   Response status:", error.response?.status);
    console.error("   Response data:", error.response?.data);
    
    if (error.response?.status === 401 || error.code === 401) {
      console.warn("⚠️ contenttypelist - 401 Unauthorized, clearing localStorage");
      localStorage.clear();
      // Don't reload automatically - let the user see the error
      // window.location.reload();
    }

    throw error.response?.data || error;
  }
};

const trainingroom = async (id) => {
  try {
    const params = {
      club_id: id,
    };

    const response = await axios.post(
      `${ip_back}api/superAdmin/trainingRoomList`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    console.log(error);
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const getmetric = async (id) => {
  try {
    const params = {
      club_id: id,
    };

    const response = await axios.post(
      `${ip_back}api/admin/dashboardMetrics`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const getdashboard = async (id) => {
  try {
    const params = {
      club_id: id,
    };

    const response = await axios.post(
      `${ip_back}api/admin/dashboardMetrics`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const getParticipantsWeeklyChart = async ({ club_id, months = 1 } = {}) => {
  try {
    const params = { months };
    if (club_id) params.club_id = club_id;

    const response = await axios.post(
      `${ip_back}api/admin/participantsWeeklyChart`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? {
      status: "error",
      message: error.message || "Network error",
    };
  }
};

const getPresenceReport = async ({ club_id, start_date, end_date }) => {
  try {
    const params = {
      club_id,
      start_date,
      end_date,
    };

    const response = await axios.post(
      `${ip_back}api/admin/presenceReport`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401 || error.response?.status === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const complist = async () => {
  try {
    const response = await axios.get(
      `${ip_back}api/admin/listBlockCom`,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const uploadExcelOfUser = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/user/uploadExcelOfUser`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const addComplist = async (value) => {
  try {
    const params = {
      language_code: value.lang,
      translation: value.text,
    };
    const response = await axios.post(
      `${ip_back}api/admin/addNewBlockCom`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }

    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const groupcreate = async (
  pictures,
  data,
  selectedtraining,
  coachlist,
  playerlist,
  date,
  room,
  numberOfTables
) => {
  try {
    const params = new FormData();
    params.append("gr_name", data.name);
    params.append("gr_des", data.des);
    params.append("gr_created_date", new Date(date));
    // Only append gr_traning_session_type if it has a valid value (not undefined, null, or empty)
    if (selectedtraining && selectedtraining !== "undefined" && selectedtraining !== "null") {
      params.append("gr_traning_session_type", selectedtraining);
    }
    params.append("players", JSON.stringify(playerlist));
    params.append("coaches", JSON.stringify(coachlist));
    params.append("club_id", data.club_id);
    params.append("troom_id", room);
    params.append("gr_number_of_tables", numberOfTables || 1);
    params.append("gr_kind", data.kind || "training");
    if (data.guestCoachName != null) {
      params.append("gr_guest_coach_name", data.guestCoachName);
    }
    if (data.joinRules !== undefined) {
      params.append(
        "gr_join_rules",
        data.joinRules == null ? "null" : JSON.stringify(data.joinRules)
      );
    }
    {
      pictures && params.append("gr_image", pictures);
    }

    const response = await axios.post(
      `${ip_back}api/admin/createGroup`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const groupupdate = async (
  pictures,
  data,
  selectedtraining,
  coachlist,
  playerlist,
  id,
  numberOfTables
) => {
  try {
    const params = new FormData();
    params.append("gr_id", id);
    params.append("gr_name", data.name);
    params.append("gr_des", data.des);
    // Only append gr_traning_session_type if it has a valid value (not undefined, null, or empty)
    if (selectedtraining && selectedtraining !== "undefined" && selectedtraining !== "null") {
      params.append("gr_traning_session_type", selectedtraining);
    }
    params.append("players", JSON.stringify(playerlist));
    params.append("coaches", JSON.stringify(coachlist));
    params.append("gr_number_of_tables", numberOfTables || 1);
    params.append("gr_kind", data.kind || "training");
    if (data.guestCoachName != null) {
      params.append("gr_guest_coach_name", data.guestCoachName);
    }
    if (data.joinRules !== undefined) {
      params.append(
        "gr_join_rules",
        data.joinRules == null ? "null" : JSON.stringify(data.joinRules)
      );
    }
    if (data.level !== undefined) {
      params.append("gr_level_classement", data.level?.classement || "");
      params.append("gr_objective_cb_ids", JSON.stringify(data.level?.objectiveCbIds || []));
    }
    {
      pictures && params.append("gr_image", pictures);
    }

    const response = await axios.post(
      `${ip_back}api/admin/updateGroup`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const grouplist = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/admin/listGroup`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const groupdetails = async (id) => {
  try {
    const params = {
      gr_id: id,
    };

    const response = await axios.post(
      `${ip_back}api/admin/groupDetails`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const getTableAvailability = async ({
  gr_id,
  troom_id,
  club_id,
  starts_at,
  duration_minutes,
} = {}) => {
  try {
    const response = await axios.post(
      `${ip_back}api/tables/availability`,
      {
        gr_id: gr_id || undefined,
        troom_id: troom_id || undefined,
        club_id: club_id || undefined,
        starts_at: starts_at || undefined,
        duration_minutes: duration_minutes || undefined,
      },
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const getTablePlanning = async ({ club_id, troom_id, gr_id, date, from, to } = {}) => {
  try {
    const params = new URLSearchParams();
    if (club_id) params.set("club_id", club_id);
    if (troom_id) params.set("troom_id", troom_id);
    if (gr_id) params.set("gr_id", gr_id);
    if (from) params.set("from", from);
    if (to) params.set("to", to);
    if (date && !from) params.set("date", date);
    const response = await axios.get(
      `${ip_back}api/tables/planning?${params.toString()}`,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const getSessionPartners = async ({ gr_id, club_id, q } = {}) => {
  try {
    const params = new URLSearchParams();
    if (gr_id) params.set("gr_id", gr_id);
    if (club_id) params.set("club_id", club_id);
    if (q) params.set("q", q);
    const response = await axios.get(
      `${ip_back}api/tables/partners?${params.toString()}`,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const startPlayerSession = async (payload) => {
  try {
    const response = await axios.post(
      `${ip_back}api/mobile-training/start-player-session`,
      payload,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const joinPlayerSession = async (payload) => {
  try {
    const response = await axios.post(
      `${ip_back}api/mobile-training/join-player-session`,
      payload,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const createsession = async (duration, time, date, typ, id) => {
  try {
    // Format time properly - backend expects TIME format (HH:mm:ss or HH:mm)
    // Input time is usually in HH:mm format from time input
    let formattedTime = time;
    if (time) {
      // Ensure time is in HH:mm format (backend TIME type accepts HH:mm or HH:mm:ss)
      if (time.match(/^\d{1,2}:\d{2}$/)) {
        // Already in HH:mm format, use as is
        formattedTime = time;
      } else if (time.match(/^\d{1,2}:\d{2}:\d{2}$/)) {
        // Already in HH:mm:ss format, use as is
        formattedTime = time;
      } else {
        // Try to parse and format
        const parsed = moment(time, ["HH:mm", "h:mm A", "HH:mm:ss"]);
        if (parsed.isValid()) {
          formattedTime = parsed.format("HH:mm");
        }
      }
    }
    
    const params = {
      ts_duration: parseInt(duration, 10),
      ts_type_id: typ,
      ts_date: moment(date).format("DD/MM/YYYY"),
      ts_start_time: formattedTime,
      gr_id: id,
    };

    console.log("📤 createsession - Sending params:", params);
    console.log("📤 createsession - Time format check:", {
      original: time,
      formatted: formattedTime,
      type: typeof formattedTime
    });

    const response = await axios.post(
      `${ip_back}api/training/createNewTS`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    console.error("❌ createsession - Error:", error);
    console.error("❌ createsession - Error response:", error.response?.data);
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data || error;
  }
};

const createSeasonalSessions = async (duration, time, startDate, endDate, selectedDays, typ, id) => {
  try {
    console.log("🔄 createSeasonalSessions - Parameters:", {
      duration,
      time,
      startDate,
      endDate,
      selectedDays,
      typ,
      id
    });
    
    // Validate all required parameters before sending
    if (!duration || !time || !startDate || !endDate || !selectedDays || !Array.isArray(selectedDays) || selectedDays.length === 0 || !typ || !id) {
      console.error("❌ createSeasonalSessions - Missing required parameters before sending:", {
        duration: !!duration,
        time: !!time,
        startDate: !!startDate,
        endDate: !!endDate,
        selectedDays: Array.isArray(selectedDays) ? selectedDays.length : "not an array",
        typ: !!typ,
        id: !!id
      });
      throw new Error("Missing required parameters: duration=" + duration + ", time=" + time + ", startDate=" + startDate + ", endDate=" + endDate + ", selectedDays=" + JSON.stringify(selectedDays) + ", typ=" + typ + ", id=" + id);
    }
    
    const params = {
      ts_duration: parseInt(duration) || 60,
      ts_start_time: time || "18:00",
      ts_start_date: moment(startDate).format("DD/MM/YYYY"),
      ts_end_date: moment(endDate).format("DD/MM/YYYY"),
      ts_days_of_week: Array.isArray(selectedDays) ? selectedDays : [],
      ts_type_id: typ,
      gr_id: id,
    };
    
    console.log("📤 createSeasonalSessions - Sending params:", params);
    console.log("   - ts_duration:", params.ts_duration);
    console.log("   - ts_start_time:", params.ts_start_time);
    console.log("   - ts_start_date:", params.ts_start_date);
    console.log("   - ts_end_date:", params.ts_end_date);
    console.log("   - ts_days_of_week:", params.ts_days_of_week, "(isArray:", Array.isArray(params.ts_days_of_week), ", length:", params.ts_days_of_week.length, ")");
    console.log("   - ts_type_id:", params.ts_type_id);
    console.log("   - gr_id:", params.gr_id);
    
    const response = await axios.post(
      `${ip_back}api/training/createSeasonalSessions`,
      params,
      headers()
    );
    
    console.log("✅ createSeasonalSessions - Response:", response.data);
    
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    console.error("❌ createSeasonalSessions - Error:", error);
    console.error("   - Response:", error.response?.data);
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data || error;
  }
};

const editsession = async (time, date, id) => {
  try {
    const params = {
      ts_date: moment(date).format("DD/MM/YYYY"),
      ts_start_time: moment(time, "HH:mm").format("h:mm A"),
      ts_id: id,
    };

    const response = await axios.post(
      `${ip_back}api/training/updateDateandTimeTS`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const updateTrainingSessionGrid = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/updateDateandTimeTS`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data || error;
  }
};

/** Update session length in minutes (planning). Uses same endpoint as grid/date updates. */
const updateSessionDuration = async ({ ts_id, ts_duration }) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/updateDateandTimeTS`,
      { ts_id, ts_duration },
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const Edituser = async (file, data, id) => {
  const params = new FormData();
  params.append("user_id", id);
  // Always send alias as string so backend receives it (empty string to clear)
  params.append("user_alias", data.alias != null ? String(data.alias) : "");
  params.append("firstName", data.fname != null ? String(data.fname) : "");
  params.append("lastName", data.lname != null ? String(data.lname) : "");
  params.append("email", data.email != null ? String(data.email) : "");
  params.append("sex", data.gender != null ? String(data.gender) : "male");
  params.append("dateBorn", data.bday != null ? String(data.bday) : "");
  params.append("height", data.height != null ? String(data.height) : "");
  params.append("weight", data.weight != null ? String(data.weight) : "");

  if (data.grip) params.append("player_grip", String(data.grip));
  if (data.hand) params.append("player_hand", String(data.hand));
  if (data.level) params.append("player_level", String(data.level));
  if (data.style) params.append("player_style", String(data.style));
  if (data.classement !== undefined && data.classement !== null) {
    params.append("fltt_classement", String(data.classement));
  }

  let clubId = "";
  try {
    const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
    clubId = String(
      data.club_id ||
        currentUser.club_id ||
        currentUser.club_details?.club_id ||
        currentUser.club?.club_id ||
        ""
    ).trim();
  } catch {
    clubId = String(data.club_id || "").trim();
  }
  if (clubId) params.append("club_id", clubId);

  {
    file && params.append("user_image", file);
  }

  try {
    const response = await axios.post(
      `${ip_back}api/admin/updateUserProfileAdmin`,
      params,
      headers()
    );
    return response;
  } catch (error) {
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const Editrole = async (role, id) => {
  let clubId = "";
  try {
    const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
    clubId = String(
      currentUser.club_id ||
        currentUser.club_details?.club_id ||
        currentUser.club?.club_id ||
        ""
    ).trim();
  } catch {
    clubId = "";
  }
  const params = {
    user_id: id,
    new_role_id: role,
    ...(clubId ? { club_id: clubId } : {}),
  };
  const roleIds = Array.isArray(role) ? role : [role];
  const wantsModerator = roleIds.includes("r9");
  let isSuperAdmin = false;
  try {
    const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
    isSuperAdmin =
      currentUser.isSuperAdmin === true || Number(currentUser.type_user_id) === 1;
  } catch {
    isSuperAdmin = false;
  }

  try {
    if (wantsModerator && isSuperAdmin) {
      const fallbackResponse = await axios.post(
        `${ip_back}api/superAdmin/updateUserRole`,
        params,
        headers()
      );
      if (fallbackResponse.data.status === "error") {
        throw fallbackResponse.data;
      }
      return fallbackResponse;
    }
    // Try admin endpoint first (for regular admins)
    const response = await axios.post(
      `${ip_back}api/admin/updateUserRole`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    // Do not fall back to Super Admin for club staff — that yields a confusing
    // "Access denied" when Moderators/Admins already hit a real 403/500.
    if (
      isSuperAdmin &&
      error.response &&
      (error.response.status === 403 ||
        error.response.status === 404 ||
        error.response.status === 500)
    ) {
      console.log(`⚠️ Admin endpoint failed with status ${error.response.status}, trying superAdmin endpoint...`);
      try {
        const fallbackResponse = await axios.post(
          `${ip_back}api/superAdmin/updateUserRole`,
          params,
          headers()
        );
        if (fallbackResponse.data.status === "error") {
          throw fallbackResponse.data;
        } else {
          console.log(`✅ SuperAdmin endpoint succeeded`);
          return fallbackResponse;
        }
      } catch (fallbackError) {
        console.error(`❌ SuperAdmin endpoint also failed:`, fallbackError);
        throw fallbackError.response ? fallbackError.response.data : fallbackError;
      }
    }
    throw error.response ? error.response.data : error;
  }
};
const sessionlist = async (grIdOrOpts, maybeOpts = {}) => {
  try {
    const opts =
      grIdOrOpts &&
      typeof grIdOrOpts === "object" &&
      !Array.isArray(grIdOrOpts)
        ? { ...grIdOrOpts }
        : { gr_id: grIdOrOpts, ...maybeOpts };

    const params = {};
    if (opts.gr_id) params.gr_id = opts.gr_id;
    if (Array.isArray(opts.gr_ids) && opts.gr_ids.length) {
      params.gr_ids = opts.gr_ids;
    }
    const selected =
      typeof opts.selected_date === "string" &&
      /^\d{4}-\d{2}-\d{2}/.test(opts.selected_date)
        ? opts.selected_date.slice(0, 10)
        : opts.selected_date
          ? moment(opts.selected_date).format("YYYY-MM-DD")
          : null;
    if (selected) params.selected_date = selected;
    const dateFrom =
      typeof opts.date_from === "string"
        ? opts.date_from.slice(0, 10)
        : opts.date_from
          ? moment(opts.date_from).format("YYYY-MM-DD")
          : null;
    const dateTo =
      typeof opts.date_to === "string"
        ? opts.date_to.slice(0, 10)
        : opts.date_to
          ? moment(opts.date_to).format("YYYY-MM-DD")
          : null;
    if (dateFrom) params.date_from = dateFrom;
    if (dateTo) params.date_to = dateTo;
    if (opts.include_hr === false) params.include_hr = false;

    const response = await axios.post(
      `${ip_back}api/training/listTS`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const sessionMonthAgenda = async ({ year, month, gr_id, gr_ids } = {}) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/sessionMonthAgenda`,
      { year, month, gr_id, gr_ids },
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const cbset = async (data, level) => {
  try {
    const params = {
      level_id: level,
      cb_data: data,
    };
    const response = await axios.post(
      `${ip_back}api/user/cb_set`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const getcb = async () => {
  try {
    const response = await axios.get(
      `${ip_back}api/user/get_cb_user`,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const getlevel = async () => {
  try {
    const response = await axios.get(
      `${ip_back}api/admin/levelsData`,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const gettype = async () => {
  try {
    const response = await axios.get(`${ip_back}api/types/getType`, headers());
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const getsubtype = async (type_id = null) => {
  try {
    // Build URL with optional type_id query parameter
    let url = `${ip_back}api/types/getSubtype`;
    if (type_id) {
      url += `?type_id=${type_id}`;
    }
    
    const response = await axios.get(url, headers());
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data || error;
  }
};
const getsubtypedefault = async () => {
  try {
    const response = await axios.get(
      `${ip_back}api/training/defaultSubTypeExercise`,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const getexercise = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/getExercise`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const generatefile = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/user/generateUserExcel`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const addexercise = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/attachExercise`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

/** Empty Live Training timer block (chrono only, no catalog exercise). */
const createLiveTimerBlock = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/createLiveTimerBlock`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const updateexercise = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/exchangeExOrCbToEx`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const personalizeExerciseForPlayer = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/personalizeExerciseForPlayer`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const changeExerciseOnResults = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/changeExerciseOnResults`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const editexercise = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/editTrainingExercise`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

/** Apply multiple planning duration edits in one request (merged validation vs session). */
const applyPlanningExerciseBatch = async ({
  ts_id,
  exercises,
  allow_duration_exceed,
}) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/applyPlanningExerciseBatch`,
      {
        ts_id,
        exercises,
        ...(allow_duration_exceed != null
          ? { allow_duration_exceed }
          : {}),
      },
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const starttraining = async () => {
  try {
    const response = await axios.get(
      `${ip_back}api/admin/traningState`,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const addwizardexercise = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/storeWizardExercise`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const sessionexlist = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/getTrainingSessionExercise`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const exdetails = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/exercises/getExerciseDetails`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const exnote = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/TE/exercisePlayerNotesGet`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const cbdata = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/cbExerciseGet`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const sessiondeleteex = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/removeExerciseFromTS`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const deleteTrainingExerciseSequence = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/removeTrainingExerciseSequence`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const deleteTrainingSession = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/deleteTrainingSession`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const duplicateTrainingSession = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/duplicateTrainingSession`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const tableplayerlist = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/TE/playerListTable`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const grpplayerlist = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/admin/groupPlayers`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const grpuserlist = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/admin/playerAndCoachgroupList`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const grpdelete = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/admin/removeGroup`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const getagreement = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/admin/getAgreement`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const getterms = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/user/termsAndConditions`,
      params
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const updateagreement = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/admin/addOrUpdateAgreement`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const userdelete = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/admin/removeUser`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const playerpresent = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/TE/presentUserTS`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const getPlayerLastSession = async (opts = {}) => {
  const token = localStorage.getItem("token");
  const params = {};
  if (opts.view_user_id) params.view_user_id = opts.view_user_id;
  if (opts.view_player_id) params.view_player_id = opts.view_player_id;
  return axios.get(`${ip_back}api/user/playerLastSession`, {
    headers: { Authorization: token },
    params: Object.keys(params).length ? params : undefined,
  });
};

const acknowledgeFlttRankingNotice = async (userId) => {
  const token = localStorage.getItem("token");
  return axios.post(
    `${ip_back}api/user/flttRankingNotice`,
    { user_id: userId },
    { headers: { Authorization: token } }
  );
};

const getPlayerProfileStats = async (opts = {}) => {
  const token = localStorage.getItem("token");
  const params = {};
  if (opts.view_user_id) params.view_user_id = opts.view_user_id;
  if (opts.view_player_id) params.view_player_id = opts.view_player_id;
  try {
    const stored = JSON.parse(localStorage.getItem("user") || "{}");
    const clubId = String(
      opts.club_id ||
        stored.club_id ||
        stored.club_details?.club_id ||
        stored.club?.club_id ||
        ""
    ).trim();
    if (clubId) params.club_id = clubId;
  } catch {
    /* ignore */
  }
  return axios.get(`${ip_back}api/user/playerProfileStats`, {
    headers: { Authorization: token },
    params: Object.keys(params).length ? params : undefined,
  });
};

const getHomeInsight = async (opts = {}) => {
  const token = localStorage.getItem("token");
  const params = {};
  if (opts.home_role) params.home_role = opts.home_role;
  if (opts.language) params.language = opts.language;
  if (opts.club_id) params.club_id = opts.club_id;
  return axios.get(`${ip_back}api/user/homeInsight`, {
    headers: { Authorization: token },
    params: Object.keys(params).length ? params : undefined,
  });
};

const updatePlayerGear = async (gear) => {
  try {
    const response = await axios.put(
      `${ip_back}api/user/updatePlayerGear`,
      gear,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

/** Coach web: add player to club (and group). Use is_active: false for invited / inactive roster entries. */
const createClubPlayerInvite = async ({ first_name, last_name, club_id, gr_id, is_active = true }) => {
  try {
    const response = await axios.post(
      `${ip_back}api/mobileAPI/createClubPlayer`,
      { first_name, last_name, club_id, gr_id, is_active },
      headers()
    );
    if (response.data?.status === "error") {
      throw response.data;
    }
    return response.data;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

/** Live training demo club: add a walk-in player (pseudo + optional names/email). */
const addDemoSessionPlayer = async ({
  pseudo,
  first_name,
  last_name,
  email,
  club_id,
  gr_id,
  ts_id,
}) => {
  try {
    const response = await axios.post(
      `${ip_back}api/TE/addDemoSessionPlayer`,
      { pseudo, first_name, last_name, email, club_id, gr_id, ts_id },
      headers()
    );
    if (response.data?.status === "error") {
      throw response.data;
    }
    return response.data;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const getDemoSourceClub = async () => {
  try {
    const response = await axios.get(`${ip_back}api/demo/source-club`, headers());
    if (response.data?.status === "error") {
      const err = httpErrorPayload(
        { response: { status: 403, data: response.data } },
        "Could not load demo look"
      );
      throw err;
    }
    return response.data.data;
  } catch (error) {
    if (error?.statusCode) throw error;
    throw httpErrorPayload(error, "Could not load demo look");
  }
};

const setDemoSourceClub = async (clubId) => {
  try {
    const response = await axios.put(
      `${ip_back}api/demo/source-club`,
      { club_id: clubId || null },
      headers()
    );
    if (response.data?.status === "error") {
      throw httpErrorPayload(
        { response: { data: response.data } },
        "Could not set demo club"
      );
    }
    return response.data.data;
  } catch (error) {
    if (error?.status === "error" || error?.statusCode) throw error;
    throw httpErrorPayload(error, "Could not set demo club");
  }
};

/** Live training: invite a guest by name + email and add them to the session group. */
const inviteTrainingSessionGuest = async ({
  first_name,
  last_name,
  email,
  club_id,
  gr_id,
  ts_id,
}) => {
  try {
    const response = await axios.post(
      `${ip_back}api/TE/inviteSessionGuest`,
      { first_name, last_name, email, club_id, gr_id, ts_id },
      headers()
    );
    if (response.data?.status === "error") {
      throw response.data;
    }
    return response.data;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const playeractive = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/admin/inActiveUser`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const tablelist = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/admin/groupTable`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const playeradtable = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/TE/assignTableToPlayer`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const playerswaptable = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/TE/swapPlayerTable`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const copyTableSetup = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/TE/copyTableSetup`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const rotatePlayers = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/TE/rotatePlayers`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const pauseexer = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/TE/pauseTrainingExercise`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const completeexer = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/TE/completeTrainingExercise
`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const exerciseswap = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/TE/updateTrainingExerciseOrder`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const getPendingAutoevaluations = async () => {
  try {
    const response = await axios.get(
      `${ip_back}api/TE/pendingAutoevaluations`,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const saveCoachExerciseEvaluation = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/TE/saveCoachExerciseEvaluation`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const addBatchAutoevaluation = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/TE/addBatchAutoevaluation`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const autoevolution = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/TE/addAutoevaluation`,
      {
        te_id: params?.te_id,
        exercise_perf: params?.exercise_perf != null ? String(params.exercise_perf) : "",
        perceived_exertion:
          params?.perceived_exertion != null ? String(params.perceived_exertion) : "",
      },
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const audioupload = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/files/voiceMessageStore`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const videoupload = async (params) => {
  try {
    assertVideoUploadAllowed();
    const response = await axios.post(
      `${ip_back}api/files/videoMessageStore`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const sendNotes = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/TE/exercisePlayerNotes`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }

    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
/**
 * True when HTTP 404 is from our HR API (route exists, no samples / not allowed payload),
 * not a missing Express route (those we fall back to legacy paths for).
 */
const isHrApiResourceNotFound = (error) => {
  const data = error?.response?.data;
  if (!data || typeof data !== "object") return false;
  return (
    data.status === "failed" ||
    data.status === "error" ||
    data.hr_rejection_reason != null
  );
};

/** Backend 200 + `failed` when this player has no HR samples (not an HTTP/route error). */
const isHrAbsenceEnvelope = (data) =>
  Boolean(data && typeof data === "object" && data.hr_rejection_reason);

/**
 * POST to the first URL that exists (legacy path fallback).
 * Does not retry when the handler returns 404 JSON for missing HR data.
 */
const postHrFirstAvailable = async (urls, params, rejectBody) => {
  let lastErr;
  for (let i = 0; i < urls.length; i++) {
    try {
      const response = await axios.post(urls[i], params, headers());
      if (rejectBody(response)) {
        throw response.data;
      }
      return response;
    } catch (error) {
      if (error.code === 401) {
        localStorage.clear();
      }
      // rejectBody() threw `response.data` — not an HTTP failure to retry
      if (!axios.isAxiosError(error)) {
        throw error;
      }
      lastErr = error;
      const st = error.response?.status;
      // Only treat bare/nginx 404 as "try next path". API 404 = no HR for this player.
      if (st === 404 && !isHrApiResourceNotFound(error) && i < urls.length - 1) {
        continue;
      }
      throw error.response?.data ?? {
        status: "error",
        message: error.message || "Network error",
      };
    }
  }
  throw lastErr?.response?.data ?? {
    status: "error",
    message: lastErr?.message || "Network error",
  };
};

const rejectHrEnvelope = (response) => {
  const data = response.data;
  if (isHrAbsenceEnvelope(data)) return false;
  return data.status === "error" || data.status === "failed";
};

const hrsummary = async (params) => {
  return postHrFirstAvailable(
    [
      `${ip_back}api/TE/playerExerciseHeartRate`,
      `${ip_back}api/exercises/userHRDataSummary`,
      `${ip_back}api/mobileAPI/playerExerciseHeartRate`,
    ],
    params,
    rejectHrEnvelope
  );
};

const playerSessionHeartRate = async (params) => {
  return postHrFirstAvailable(
    [
      `${ip_back}api/TE/playerSessionHeartRate`,
      `${ip_back}api/mobileAPI/playerSessionHeartRate`,
    ],
    params,
    rejectHrEnvelope
  );
};

/** Latest HR row per user for a training exercise — used to see which players have HR data. */
const getCurrentHeartRates = async (params) => {
  return postHrFirstAvailable(
    [
      `${ip_back}api/TE/getCurrentHeartRates`,
      `${ip_back}api/exercises/getCurrentHeartRates`,
      `${ip_back}api/mobileAPI/getCurrentHeartRates`,
    ],
    params,
    (response) =>
      response.data.status === "error" || response.data.status === "failed"
  );
};

/** Logged-in player's roster seat for HR uploads (`POST /api/exercises/myHrRoster`). */
const myHrRoster = async ({ te_id, table_id }) => {
  const body = { te_id };
  if (table_id != null && table_id !== "") body.table_id = table_id;
  const response = await axios.post(
    `${ip_back}api/exercises/myHrRoster`,
    body,
    headers()
  );
  if (response.data.status === "failed" || response.data.status === "error") {
    throw response.data;
  }
  return response;
};

/** TE pipeline debug snapshot (`POST /api/exercises/tePipelineDebug`). */
const tePipelineDebug = async (params) => {
  const response = await axios.post(
    `${ip_back}api/exercises/tePipelineDebug`,
    params,
    headers()
  );
  if (response.data.status === "failed" || response.data.status === "error") {
    throw response.data;
  }
  return response;
};

/** Fetch feedback messages for a training exercise (`POST /api/mobileAPI/getExerciseFeedback`). */
const getExerciseFeedback = async (params) => {
  const response = await axios.post(
    `${ip_back}api/mobileAPI/getExerciseFeedback`,
    params,
    headers()
  );
  if (response.data.status === "failed" || response.data.status === "error") {
    throw response.data;
  }
  return response;
};

/** Group roster — same contract as iOS (`POST /api/mobileAPI/groupPlayers`). */
const mobileGroupPlayers = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/mobileAPI/groupPlayers`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

/** Session roster + tables — same contract as iOS (`POST /api/mobileAPI/sessionDetails`). */
const mobileSessionDetails = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/mobileAPI/sessionDetails`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

export default profile;
export {
  profile,
  getMyClubs,
  switchClub,
  playeractive,
  editprofile,
  changepassword,
  homepageadmin,
  homepageuser,
  homemetric,
  usertype,
  alluserlist,
  playerlist,
  coachlist,
  contenttypelist,
  complist,
  addComplist,
  groupcreate,
  groupupdate,
  grouplist,
  groupdetails,
  createsession,
  getTableAvailability,
  getTablePlanning,
  getSessionPartners,
  startPlayerSession,
  joinPlayerSession,
  createSeasonalSessions,
  starttraining,
  sessionlist,
  sessionMonthAgenda,
  cbset,
  getcb,
  getlevel,
  gettype,
  getsubtype,
  getexercise,
  addexercise,
  createLiveTimerBlock,
  sessionexlist,
  sessiondeleteex,
  deleteTrainingExerciseSequence,
  deleteTrainingSession,
  duplicateTrainingSession,
  getsubtypedefault,
  addwizardexercise,
  editexercise,
  applyPlanningExerciseBatch,
  exdetails,
  cbdata,
  updateexercise,
  personalizeExerciseForPlayer,
  changeExerciseOnResults,
  grpplayerlist,
  playerpresent,
  createClubPlayerInvite,
  inviteTrainingSessionGuest,
  addDemoSessionPlayer,
  getDemoSourceClub,
  setDemoSourceClub,
  getPlayerLastSession,
  getPlayerProfileStats,
  acknowledgeFlttRankingNotice,
  getHomeInsight,
  updatePlayerGear,
  tablelist,
  tableplayerlist,
  playeradtable,
  playerswaptable,
  copyTableSetup,
  rotatePlayers,
  pauseexer,
  completeexer,
  exerciseswap,
  autoevolution,
  getPendingAutoevaluations,
  addBatchAutoevaluation,
  saveCoachExerciseEvaluation,
  grpuserlist,
  audioupload,
  videoupload,
  exnote,
  sendNotes,
  grpdelete,
  userdelete,
  getagreement,
  getterms,
  updateagreement,
  generatefile,
  changelang,
  uploadExcelOfUser,
  trainingroom,
  getdashboard,
  getParticipantsWeeklyChart,
  getPresenceReport,
  editsession,
  updateTrainingSessionGrid,
  updateSessionDuration,
  Edituser,
  superadminchangepassword,
  superadmineditprofile,
  allclublist,
  getClubLicenseUsage,
  getPilotWeeklyDigest,
  getPilotBiClubs,
  getCaptureQosSummary,
  downloadPilotWeeklyDigestCsv,
  postChampionSignal,
  getClubUsers,
  deleteClub,
  updateClubFromFLTT,
  listFlttMatchProposals,
  decideFlttMatchProposal,
  addclub,
  importClubFromWebsite,
  updateclub,
  uploadClubLogo,
  allpermissions,
  allroles,
  addroles,
  updateroles,
  troomlist,
  Editrole,
  hrsummary,
  playerSessionHeartRate,
  getCurrentHeartRates,
  myHrRoster,
  getExerciseFeedback,
  tePipelineDebug,
  mobileGroupPlayers,
  mobileSessionDetails,
  sendinvite,
  inviteuserinfo,
  getTrainingRoomsByClub,
  getAllTrainingRooms,
  createTrainingRoom,
  updateTrainingRoom,
  deleteTrainingRoom,
  geocodeTrainingRoom,
  invitePlayerToRegister,
  inviteClubMember,
  inviteClubAdmin,
  listTrainingGuests,
  createTrainingGuest,
  refreshTrainingGuestMatches,
  linkTrainingGuest,
  validateTrainingGuest,
  getClubJoinInfo,
  createTrainingSessionTemplate,
  createStandardTrainingSessionTemplate,
  getSessionTemplateCatalog,
  getTrainingSessionTemplates,
  searchCatalogExercises,
  getTrainingSessionTemplateById,
  updateTrainingSessionTemplate,
  deleteTrainingSessionTemplate,
  applyTrainingSessionTemplate,
  saveCaptureSegment,
  listCaptureSession,
  proposeCaptureSession,
  confirmCaptureBlock,
  listSessionSubgroups,
  createSessionSubgroup,
  updateSessionSubgroup,
  deleteSessionSubgroup,
  swapTrainingBlockExercises,
  syncBlockExercise,
  createNewcomer,
  ensureFlttForm,
  getNewcomerDossier,
  getPublicNewcomerDossier,
  saveNewcomerFacts,
  uploadNewcomerDocument,
  verifyNewcomerDocument,
  signNewcomerDossier,
  newcomerFormPdfUrl,
  recordNewcomerPayment,
  startNewcomerCardPayment,
  confirmNewcomerCardPayment,
  saveNewcomerLicence,
  getNewcomerPaymentSettings,
  saveNewcomerPaymentSettings,
};

// Training Room Functions
const getTrainingRoomsByClub = async (clubId) => {
  try {
    const response = await axios.get(
      `${ip_back}api/training-rooms/club/${clubId}`,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data || error;
  }
};

const getAllTrainingRooms = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams(params).toString();
    const response = await axios.get(
      `${ip_back}api/training-rooms?${queryParams}`,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data || error;
  }
};

const createTrainingRoom = async (data) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training-rooms`,
      data,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data || error;
  }
};

const updateTrainingRoom = async (troomId, data) => {
  try {
    const response = await axios.put(
      `${ip_back}api/training-rooms/${troomId}`,
      data,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data || error;
  }
};

const deleteTrainingRoom = async (troomId) => {
  try {
    const response = await axios.delete(
      `${ip_back}api/training-rooms/${troomId}`,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data || error;
  }
};

const geocodeTrainingRoom = async (troomId) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training-rooms/${troomId}/geocode`,
      {},
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data || error;
  }
};

// Player Invitation Function
const invitePlayerToRegister = async (userId, email) => {
  try {
    const params = {
      user_id: userId,
      email: email
    };
    const response = await axios.post(
      `${ip_back}api/admin/invitePlayer`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response.data;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data || error;
  }
};

const inviteClubMember = async ({ email, first_name, last_name, club_id, players, as_guest, as_parent, invite_role } = {}) => {
  try {
    const params = players?.length
      ? { players, club_id, as_guest: !!as_guest, as_parent: !!as_parent, invite_role }
      : { email, first_name, last_name, club_id, as_guest: !!as_guest, as_parent: !!as_parent, invite_role };
    const response = await axios.post(
      `${ip_back}api/admin/inviteClubMember`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response.data;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data || error;
  }
};

const inviteClubAdmin = async ({ email, first_name, last_name, club_id, invite_role } = {}) => {
  try {
    const response = await axios.post(
      `${ip_back}api/admin/inviteClubAdmin`,
      { email, first_name, last_name, club_id, invite_role },
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response.data;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data || error;
  }
};

const listTrainingGuests = async (club_id) => {
  try {
    const response = await axios.post(
      `${ip_back}api/admin/listTrainingGuests`,
      { club_id },
      headers()
    );
    if (response.data.status === "error") throw response.data;
    return response.data;
  } catch (error) {
    if (error.code === 401) localStorage.clear();
    throw error.response?.data || error;
  }
};

const createTrainingGuest = async ({ club_id, nickname, gr_id, guest_license_threshold } = {}) => {
  try {
    const response = await axios.post(
      `${ip_back}api/admin/createTrainingGuest`,
      { club_id, nickname, gr_id, guest_license_threshold },
      headers()
    );
    if (response.data.status === "error") throw response.data;
    return response.data;
  } catch (error) {
    if (error.code === 401) localStorage.clear();
    throw error.response?.data || error;
  }
};

const refreshTrainingGuestMatches = async ({ club_id, player_id } = {}) => {
  try {
    const response = await axios.post(
      `${ip_back}api/admin/refreshTrainingGuestMatches`,
      { club_id, player_id },
      headers()
    );
    if (response.data.status === "error") throw response.data;
    return response.data;
  } catch (error) {
    if (error.code === 401) localStorage.clear();
    throw error.response?.data || error;
  }
};

const linkTrainingGuest = async ({ guest_player_id, official_player_id } = {}) => {
  try {
    const response = await axios.post(
      `${ip_back}api/admin/linkTrainingGuest`,
      { guest_player_id, official_player_id },
      headers()
    );
    if (response.data.status === "error") throw response.data;
    return response.data;
  } catch (error) {
    if (error.code === 401) localStorage.clear();
    throw error.response?.data || error;
  }
};

const validateTrainingGuest = async ({ guest_player_id } = {}) => {
  try {
    const response = await axios.post(
      `${ip_back}api/admin/validateTrainingGuest`,
      { guest_player_id },
      headers()
    );
    if (response.data.status === "error") throw response.data;
    return response.data;
  } catch (error) {
    if (error.code === 401) localStorage.clear();
    throw error.response?.data || error;
  }
};

const getClubJoinInfo = async (clubCode) => {
  try {
    const response = await axios.get(
      `${ip_back}api/club/join/${encodeURIComponent(clubCode)}`
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Training Session Template Functions
const createTrainingSessionTemplate = async (data) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/template/create`,
      data,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data || error;
  }
};

const createStandardTrainingSessionTemplate = async (data) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/template/create-standard-model`,
      data,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data || error;
  }
};

const getSessionTemplateCatalog = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams(params).toString();
    const response = await axios.get(
      `${ip_back}api/training/template/catalog${queryParams ? `?${queryParams}` : ""}`,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data || error;
  }
};

const getTrainingSessionTemplates = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams(params).toString();
    const response = await axios.get(
      `${ip_back}api/training/template/list?${queryParams}`,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data || error;
  }
};

const searchCatalogExercises = async (params = {}) => {
  try {
    const response = await axios.get(`${ip_back}api/training/template/catalog-exercises`, {
      ...headers(),
      params,
    });
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data || error;
  }
};

const getTrainingSessionTemplateById = async (tst_id) => {
  try {
    const response = await axios.get(
      `${ip_back}api/training/template/${tst_id}`,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data || error;
  }
};

const updateTrainingSessionTemplate = async (tst_id, data) => {
  try {
    const response = await axios.put(
      `${ip_back}api/training/template/${tst_id}`,
      data,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data || error;
  }
};

const deleteTrainingSessionTemplate = async (tst_id) => {
  try {
    const response = await axios.delete(
      `${ip_back}api/training/template/${tst_id}`,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    } else {
      return response;
    }
  } catch (error) {
    if (error.code === 401) {
      localStorage.clear();
    }
    throw error.response?.data || error;
  }
};

const saveCaptureSegment = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/capture/segment`,
      params,
      headers()
    );
    if (response.data.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error?.response?.status === 401) localStorage.clear();
    throw error?.response?.data || error;
  }
};

const listCaptureSession = async (tsId) => {
  try {
    const response = await axios.get(
      `${ip_back}api/training/capture/${tsId}`,
      headers()
    );
    if (response.data.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error?.response?.status === 401) localStorage.clear();
    throw error?.response?.data || error;
  }
};

const proposeCaptureSession = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/capture/propose`,
      params,
      headers()
    );
    if (response.data.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error?.response?.status === 401) localStorage.clear();
    throw error?.response?.data || error;
  }
};

const confirmCaptureBlock = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/capture/confirm`,
      params,
      headers()
    );
    if (response.data.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error?.response?.status === 401) localStorage.clear();
    throw error?.response?.data || error;
  }
};

const applyTrainingSessionTemplate = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/template/apply`,
      params,
      headers()
    );
    if (response.data.status === "error") {
      throw response.data;
    }
    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      localStorage.clear();
    }
    throw error?.response?.data || error;
  }
};

const listSessionSubgroups = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/subgroups`,
      params,
      headers()
    );
    if (response.data.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error?.response?.status === 401) localStorage.clear();
    throw error?.response?.data || error;
  }
};

const createSessionSubgroup = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/subgroups/create`,
      params,
      headers()
    );
    if (response.data.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error?.response?.status === 401) localStorage.clear();
    throw error?.response?.data || error;
  }
};

const updateSessionSubgroup = async (tsgId, params) => {
  try {
    const response = await axios.put(
      `${ip_back}api/training/subgroups/${tsgId}`,
      params,
      headers()
    );
    if (response.data.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error?.response?.status === 401) localStorage.clear();
    throw error?.response?.data || error;
  }
};

const deleteSessionSubgroup = async (tsgId) => {
  try {
    const response = await axios.delete(
      `${ip_back}api/training/subgroups/${tsgId}`,
      headers()
    );
    if (response.data.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error?.response?.status === 401) localStorage.clear();
    throw error?.response?.data || error;
  }
};

const swapTrainingBlockExercises = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/subgroups/swapExercises`,
      params,
      headers()
    );
    if (response.data.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error?.response?.status === 401) localStorage.clear();
    throw error?.response?.data || error;
  }
};

const ensureFlttForm = async ({ user_id, club_id } = {}) => {
  try {
    const response = await axios.post(
      `${ip_back}api/admin/fltt-form`,
      { user_id, club_id },
      headers()
    );
    if (response.data.status === "error") throw response.data;
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) localStorage.clear();
    throw error?.response?.data || error;
  }
};

const createNewcomer = async (body) => {
  try {
    const response = await axios.post(`${ip_back}api/admin/newcomer`, body, headers());
    if (response.data.status === "error") throw response.data;
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) localStorage.clear();
    throw error?.response?.data || error;
  }
};

const getNewcomerDossier = async (dossierId) => {
  try {
    const response = await axios.get(`${ip_back}api/admin/newcomer/${dossierId}`, headers());
    if (response.data.status === "error") throw response.data;
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) localStorage.clear();
    throw error?.response?.data || error;
  }
};

const getPublicNewcomerDossier = async (token) => {
  const response = await axios.get(`${ip_back}api/public/newcomer/${token}`);
  if (response.data.status === "error") throw response.data;
  return response.data;
};

const saveNewcomerFacts = async ({ dossierId, token, facts }) => {
  const url = token
    ? `${ip_back}api/public/newcomer/${token}/facts`
    : `${ip_back}api/admin/newcomer/${dossierId}/facts`;
  const config = token ? {} : headers();
  const response = await axios.patch(url, facts, config);
  if (response.data.status === "error") throw response.data;
  return response.data;
};

const uploadNewcomerDocument = async ({ dossierId, token, kind, file }) => {
  const form = new FormData();
  form.append("kind", kind);
  form.append("file", file);
  const url = token
    ? `${ip_back}api/public/newcomer/${token}/documents`
    : `${ip_back}api/admin/newcomer/${dossierId}/documents`;
  const config = token ? {} : headers();
  const response = await axios.post(url, form, config);
  if (response.data.status === "error") throw response.data;
  return response.data;
};

const verifyNewcomerDocument = async (dossierId, documentId) => {
  const response = await axios.post(
    `${ip_back}api/admin/newcomer/${dossierId}/documents/${documentId}/verify`,
    {},
    headers()
  );
  if (response.data.status === "error") throw response.data;
  return response.data;
};

const signNewcomerDossier = async ({ token, dossierId, strokes, signer_name }) => {
  const url = token
    ? `${ip_back}api/public/newcomer/${token}/sign`
    : `${ip_back}api/admin/newcomer/${dossierId}/sign`;
  const config = token ? {} : headers();
  const response = await axios.post(url, { strokes, signer_name, confirm: true }, config);
  if (response.data.status === "error") throw response.data;
  return response.data;
};

const newcomerFormPdfUrl = ({ token, dossierId }) =>
  token
    ? `${ip_back}api/public/newcomer/${token}/form.pdf`
    : `${ip_back}api/admin/newcomer/${dossierId}/form.pdf`;

const recordNewcomerPayment = async (dossierId, body) => {
  const response = await axios.post(
    `${ip_back}api/admin/newcomer/${dossierId}/payments`,
    body,
    headers()
  );
  if (response.data.status === "error") throw response.data;
  return response.data;
};

const startNewcomerCardPayment = async ({ dossierId, token, kind, session_date }) => {
  const url = token
    ? `${ip_back}api/public/newcomer/${token}/payments/stripe`
    : `${ip_back}api/admin/newcomer/${dossierId}/payments/stripe`;
  const config = token ? {} : headers();
  const response = await axios.post(url, { kind, session_date }, config);
  if (response.data.status === "error") throw response.data;
  return response.data;
};

const confirmNewcomerCardPayment = async (token, paymentId) => {
  const response = await axios.post(
    `${ip_back}api/public/newcomer/${token}/payments/${paymentId}/confirm`
  );
  if (response.data.status === "error") throw response.data;
  return response.data;
};

const saveNewcomerLicence = async (dossierId, licence_number) => {
  const response = await axios.post(
    `${ip_back}api/admin/newcomer/${dossierId}/licence`,
    { licence_number },
    headers()
  );
  if (response.data.status === "error") throw response.data;
  return response.data;
};

const getNewcomerPaymentSettings = async (clubId) => {
  const response = await axios.get(
    `${ip_back}api/admin/newcomer/payment-settings`,
    { ...headers(), params: clubId ? { club_id: clubId } : undefined }
  );
  if (response.data.status === "error") throw response.data;
  return response.data;
};

const saveNewcomerPaymentSettings = async (body) => {
  const response = await axios.put(
    `${ip_back}api/admin/newcomer/payment-settings`,
    body,
    headers()
  );
  if (response.data.status === "error") throw response.data;
  return response.data;
};

const syncBlockExercise = async (params) => {
  try {
    const response = await axios.post(
      `${ip_back}api/training/subgroups/syncBlockExercise`,
      params,
      headers()
    );
    if (response.data.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error?.response?.status === 401) localStorage.clear();
    throw error?.response?.data || error;
  }
};

